import { render, staticRenderFns } from "./UserChallenges.vue?vue&type=template&id=438268f7&scoped=true&"
import script from "./UserChallenges.vue?vue&type=script&lang=js&"
export * from "./UserChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438268f7",
  null
  
)

export default component.exports